import {
  START_LOADING,
  END_LOADING,
  FETCH_PROPERTIES,
  FETCH_PROPERTY,
  CREATE_PROPERTY,
  UPDATE_PROPERTY,
  DELETE_PROPERTY,
  SEARCH_PROPERTIES,
  PROPERTY_ERROR
} from "../actions/constants";

const initialState = {
  isLoading: false,
  properties: [],
  property: null,
  error: null,
  numberOfPages: 1
};

const properties = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true, error: null };
    
    case END_LOADING:
      return { ...state, isLoading: false };
    
    case FETCH_PROPERTIES:
      return {
        ...state,
        properties: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
        error: null
      };
    
    case FETCH_PROPERTY:
      return { 
        ...state, 
        property: action.payload,
        error: null
      };
    
    case CREATE_PROPERTY:
      return {
        ...state,
        properties: [...state.properties, action.payload],
        property: action.payload,
        error: null
      };
    
    case UPDATE_PROPERTY:
      return {
        ...state,
        properties: state.properties.map((property) =>
          property._id === action.payload._id ? action.payload : property
        ),
        property:
          state.property && state.property._id === action.payload._id
            ? action.payload
            : state.property,
        error: null
      };
    
    case DELETE_PROPERTY:
      return {
        ...state,
        properties: state.properties.filter(
          (property) => property._id !== action.payload
        ),
        property:
          state.property && state.property._id === action.payload
            ? null
            : state.property,
        error: null
      };
    
    case SEARCH_PROPERTIES:
      return {
        ...state,
        properties: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
        error: null
      };
    
    case PROPERTY_ERROR:
      return {
        ...state,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default properties;
